import { render, staticRenderFns } from "./PlacementTestTable.vue?vue&type=template&id=7fd2e3f2"
import script from "./PlacementTestTable.vue?vue&type=script&lang=js"
export * from "./PlacementTestTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports